/* eslint-disable */
import React from 'react';


 
/* var Loader = require('react-loader'); */

 class App extends React.Component {
 constructor(props, context) {
		super(props, context);
	 
	
		 
}
  render() {
    return (
	   <div> {this.props.children}  </div>
	 ); 
	 }
 }
    
export default App;


// WEBPACK FOOTER //
// ./src/App.js